import type {
  ReturnRequestShippingInfoDto,
  ShopLocationDto,
} from "@babackapp/private-api-client";
import { getCarrierLabel } from "@babackapp/carriers-utils";

/**
 * How the parcel leaves the customer's hands:
 * - `store`: dropped off at one of the shop's stores
 * - `warehouse`: shipped by the customer, with the carrier of their choice
 * - `carrier`: handled by the carrier booked by the shop
 */
export type ReturnMethodKind = "store" | "warehouse" | "carrier";

export function resolveReturnMethodKind(
  shippingInfo: ReturnRequestShippingInfoDto,
): ReturnMethodKind {
  if (shippingInfo.returnStoreId) return "store";
  if (shippingInfo.carrier === "customer-carrier") return "warehouse";
  return "carrier";
}

/**
 * Where a customer-shipped parcel has to be sent. Mirrors the legacy widget:
 * the location carried by the return request when it still exists on the shop,
 * the first one otherwise.
 */
export function resolveReturnLocation(
  locations: ShopLocationDto[],
  locationId?: string | null,
): ShopLocationDto | null {
  const requested = locationId
    ? locations.find((location) => location.id === locationId)
    : undefined;
  return requested ?? locations[0] ?? null;
}

/** getCarrierLabel echoes the raw code when unmapped: treat that as "no label". */
export function resolveCarrierLabel(
  carrierTitle?: string | null,
  carrier?: string | null,
): string | null {
  if (carrierTitle) return carrierTitle;
  if (!carrier) return null;
  const label = getCarrierLabel(carrier);
  return label !== carrier ? label : null;
}
